import { AbstractControl, ValidationErrors, Validators } from "@angular/forms";

export function requiredFalse(control: AbstractControl): ValidationErrors | null {
    return control.value === true ? {'required': true} : null;
}